import { makeStyles, createStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const brandStyles = {
  forreston: {
    logo: {
      height: 25
    }
  },
  oakwood: {
    logo: {
      height: 32
    }
  },
  // CFM logo is a taller mark (102×48) than the Forreston/Oakwood wordmarks; without an entry it
  // falls to the 48px default and towers over the header. Only height is set (like oakwood); width
  // follows the source's intrinsic aspect ratio (~68px at 32px tall), matching sibling visual
  // weight. Height is a proportional estimate — confirm with design.
  cfm: {
    logo: {
      height: 32
    }
  }
};

export default makeStyles((theme) =>
  createStyles({
    header: {
      height: theme.sizes.headerHeight,
      backgroundColor: theme.colors.header__background_primary,
      justifyContent: 'center',
      display: 'block',
      ...reskinStyles(theme, {
        borderBottom: `1px solid ${theme.colorPalette.beige_60}`,
        boxShadow: theme.surfaceShadows.header
      })
    },
    // Let the header grow to fit the taller self-contained lockup instead of clamping to headerHeight.
    headerFlexible: {
      height: 'auto',
      minHeight: theme.sizes.headerHeight
    },
    logoLockup: {
      display: 'flex',
      alignItems: 'center'
    },
    logo: ({ brandName }) => ({
      height: 48,
      marginLeft: 15,
      display: 'block',
      ...(brandStyles[brandName]?.logo || {})
    }),
    partnerLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      borderLeft: `1px solid ${theme.colorPalette.beige_75}`
    },
    partnerLogo: {
      height: 36,
      maxWidth: 180,
      objectFit: 'contain'
    },
    // Self-contained lockup stands in for the Branch logo (no divider), sized up via the flexible header.
    partnerLogoSelfContained: {
      height: 120,
      maxWidth: 560,
      marginLeft: 15,
      objectFit: 'contain',
      display: 'block'
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      height: theme.sizes.headerHeight
    },
    toolbarFlexible: {
      height: 'auto',
      minHeight: theme.sizes.headerHeight,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    searchContainer: {
      width: '100%'
    }
  })
);
